import { ContentSection2Up, ContentSectionColumn } from "components/layout";
import * as React from "react";
import { PrintViewSection, PrintViewSectionProps } from "./print-view-section";

export const PrintableForm = ({ sections }: { sections: PrintViewSectionProps[] }) => {
    return (
        <div className="max-w-[816px] mx-auto">
            <ContentSection2Up>
                <ContentSectionColumn>
                    {sections.map(section => (
                        <div className="mt-8" key={section.title}>
                            <PrintViewSection
                                title={section.title}
                                fields={section.fields}>
                                {section.children}
                            </PrintViewSection>
                        </div>
                    ))}
                </ContentSectionColumn>
            </ContentSection2Up>
        </div>
    );
};
